import {
  ControlOutlined,
  IdcardOutlined,
  PicLeftOutlined,
  SettingOutlined,
} from '@ant-design/icons'
import OrganisationAvatar from 'Components/Avatar/OrganisationAvatar'
import MenuItem from 'Components/Menu/MenuItem'
import { useCurrentOrganisation } from 'Hooks/useCurrentOrganisation'
import { HomeRow, MenuTitle } from 'Layouts/styled'
import { AuthorizationWrapperV2 } from 'Models/AuthorizeV2/checkAuthorizationV2'
import { isSkitUser } from 'Utils/isSkitUser'
import PolicyMappings from 'Utils/policyMapping'
import React from 'react'
import { Outlet, useParams } from 'react-router'
import SubMenu from '../../Components/Menu/SubMenu'
import AuthBaseLayout from '../AuthBaseLayout'

export const Organisation: React.FC<any> = ({ children, ...props }) => {
  const { organisation, isPending } = useCurrentOrganisation()
  const params = useParams()
  const organisationUuid = params?.organisation_uuid

  const campaignMenuItems = []
  campaignMenuItems.push(
    <MenuItem
      key={'voice-campaign'}
      to={`/clients/${organisationUuid}/campaigns-b/voice`}
      selected={location?.pathname?.includes('/campaigns-b/voice')}
      subMenuItem
    >
      Voice
    </MenuItem>
  )

  campaignMenuItems.push(
    <AuthorizationWrapperV2 requiredPolicies={PolicyMappings.smsCampaignsView}>
      <MenuItem
        key={'sms-campaign'}
        to={`/clients/${organisationUuid}/campaigns-b/sms`}
        selected={location?.pathname?.includes('/campaigns-b/sms')}
        subMenuItem
      >
        SMS
      </MenuItem>
    </AuthorizationWrapperV2>
  )

  return !isPending ? (
    <AuthBaseLayout
      collapsibleSideNav={true}
      sideMenuProps={{
        style: {
          justifyContent: 'space-between',
        },
      }}
      bottomMenu={
        isSkitUser() === true
          ? [
              <AuthorizationWrapperV2
                key={'client-settings'}
                requiredPolicies={PolicyMappings.viewClientSettings}
              >
                <MenuItem
                  key="settings"
                  to={`/clients/${organisationUuid}/settings/general`}
                  icon={<SettingOutlined />}
                >
                  Client Settings
                </MenuItem>
              </AuthorizationWrapperV2>,
            ]
          : null
      }
      menu={[
        <AuthorizationWrapperV2
          key="campaigns-part-b"
          requiredPolicies={PolicyMappings.clientCampaignsView}
        >
          <SubMenu
            key="campaigns-b"
            submenuKey={'campaigns-b'}
            title="Campaigns"
            icon={<ControlOutlined />}
            children={campaignMenuItems}
          />
        </AuthorizationWrapperV2>,
        <SubMenu
          title="Digital Agents"
          submenuKey={'digital_agents'}
          icon={<PicLeftOutlined />}
          key="digital_agents"
          theme="light"
        >
          <MenuItem key="voice-agents" to={`/clients/${organisationUuid}/voice-agents`} subMenuItem>
            Voice Agents
          </MenuItem>
          <AuthorizationWrapperV2 requiredPolicies={PolicyMappings.smsAgentsView}>
            <MenuItem key="sms-agents" to={`/clients/${organisationUuid}/sms-agents`} subMenuItem>
              SMS Agents
            </MenuItem>
          </AuthorizationWrapperV2>
          <AuthorizationWrapperV2 requiredPolicies={PolicyMappings.smsAgentsView}>
            <MenuItem
              key="email-agents"
              to={`/clients/${organisationUuid}/email-agents`}
              subMenuItem
            >
              Email Agents
            </MenuItem>
          </AuthorizationWrapperV2>
        </SubMenu>,
        // Not needed anymore
        // <MenuItem
        //   key="applications"
        //   to={`/clients/${organisationUuid}/applications`}
        //   icon={<HomeOutlined />}
        // >
        //   My Applications
        // </MenuItem>,
        <AuthorizationWrapperV2
          key={'business-config-control'}
          requiredPolicies={[
            ...PolicyMappings.appBusinessConfigurationCreate,
            ...PolicyMappings.appBusinessConfigurationEdit,
            ...PolicyMappings.appBusinessConfigurationView,
          ]}
        >
          <SubMenu
            title="Business Configuration"
            submenuKey={'business_configuration'}
            icon={<PicLeftOutlined />}
            key="business_configuration"
            theme="light"
          >
            <MenuItem
              key="outbound-configurations"
              to={`/clients/${organisationUuid}/business-config/outbound`}
              title={'Outbound Configuration'}
              subMenuItem
            >
              Outbound Configurations
            </MenuItem>
            <MenuItem
              key="inbound-configurations"
              to={`/clients/${organisationUuid}/business-config/inbound`}
              title={'Inbound Configuration'}
              subMenuItem
            >
              Inbound Configurations
            </MenuItem>
          </SubMenu>
        </AuthorizationWrapperV2>,
        <MenuItem
          key="account-manager"
          to={`/clients/${organisationUuid}/account-manager`}
          icon={<IdcardOutlined />}
        >
          Accounts manager
        </MenuItem>,
      ]}
      headerRender={({ theme, collapsed }: any) => (
        <HomeRow theme={theme}>
          <OrganisationAvatar name={organisation?.name} />
          {!collapsed ? <MenuTitle theme={theme}>{organisation?.name}</MenuTitle> : null}
        </HomeRow>
      )}
    >
      <Outlet />
      {children}
    </AuthBaseLayout>
  ) : null
}
